import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BcmService } from '@modules/bcm/bcm.service';
import { Tenant } from '@shared/models/tenant';

@Component({
    selector: 'avv-notice',
    templateUrl: './avv-notice.component.html',
    standalone: false
})
export class AvvNoticeComponent {

    tenant: Tenant;

    constructor(private _dialogRef: MatDialogRef<AvvNoticeComponent>,
                private _bcmService: BcmService) {
        this._dialogRef.addPanelClass('default-dialog');
        this._bcmService.selectedTenant$.subscribe(tenant => this.tenant = tenant);
    }

    onClickClose(): void {
        this._dialogRef.close();
    }
}
